import {PropositionStatus} from './master-proposal.model';

export class MasterProposalLine {
    // id de saisine
    constructor(public id?: number,
                public saisineId?: number,
                public masterInm?: string,
                public masterLabel?: string,
                public masterSchoolName?: string,
                public academicRegionLabel?: string,
                public academyLabel?: string,
                public specialityLabel?: string,
                public lastModificationDate?: any,
                public status?: PropositionStatus,
                public reference?: string,
                public licenceAcademicRegionLabel?: string,
                public licenceAcademyLabel?: string,
                public masterSchoolUai?: string,
                public formationLabel?: string
    ) {}
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master-proposal/master-proposal-line.model.ts